export default __webpack_public_path__ + "static/media/hadOne.b401ec6d.jpg";